import { Box } from "@mui/material";
import { NotificationsProvider } from "@toolpad/core";
import React from "react";
import { RouterProvider } from "react-router-dom";
import { AuthProvider } from "./provider/AuthProvider";
import ThemeProviderEx from "./provider/ThemeProviderEx";
import router from "./router";

function App() {
  return (
    <ThemeProviderEx>
      <NotificationsProvider
        slotProps={{
          snackbar: {
            anchorOrigin: { vertical: "top", horizontal: "center" },
          },
        }}
      >
        <AuthProvider>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              minHeight: "100vh",
              maxWidth: "100%",
              margin: 0,
            }}
          >
            <RouterProvider router={router} />
          </Box>
        </AuthProvider>
      </NotificationsProvider>
    </ThemeProviderEx>
  );
}

export default App;
